export default "__VITE_ASSET__BaLQVnSr__"